// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  Theme Responsive Css */


@media only screen and (max-width: 5000px){
  
    .boxed_wrapper{
      overflow: hidden;
    }
  
  }
  
  
  @media only screen and (max-width: 1849px){
  
    .main-header.style-two .logo-box{
      margin-right: 0px;
    }
  
  }
  
  
  
  @media only screen and (max-width: 991px){
  
    .main-header .header-top .location-box{
      border-left: none;
      border-right: none;
    }
  
    .main-header .header-top .right-info{
     }
  
    .main-header .outer-box{
      position: relative;
    }
  
    .main-header .outer-box .menu-area{
      float: none;
      display: block;
      text-align: center;
    }
  
    .main-header .logo-box{
      float: none;
      margin-right: 0px;
      border-radius: 0px;
    }
  
    .main-header .menu-right-content{
      position: absolute;
      right: 0px;
      top: 21px;
      margin: 0px;
    }
  
    .main-header .sticky-header .menu-right-content{
      position: relative;
      top: 0px;
    }
  
    .main-header  .main-menu  {
      max-width: 920px;
      margin: 0 auto;
      float: none;
    }
  
    .main-header.onepage  .main-menu   {
      max-width: 650px;
    }
  
    .main-header .logo-box{
      text-align: left;
    }
  
    .main-header .menu-right-content .theme-btn-one{
      background: #002c5d;
    }
  
    .main-header .menu-right-content .theme-btn-one:hover{
      color: #002c5d !important;
    }
  
    .main-header .menu-right-content .theme-btn-one:after{
      background: #fff;
    }
  
    .main-header .menu-right-content .search-btn button{
      color: #fff
    }
  
    .main-header .menu-right-content .search-btn button:hover{
      color: #002c5d !important;
    }
  
    .main-header .sticky-header .menu-right-content .search-btn button{
      color: #000
    }
  
    .sticky-header .logo-box{
      display: none;
    }
  
    .main-header .sticky-header .outer-box .menu-area{
      float: left;
      padding-left: 50px;
    }
  
    .main-header.style-two .sticky-header .menu-right-content .search-btn button{
      color: #fff;
    }
  
    .main-header.style-three .header-lower .outer-box .menu-area{
      width: 100%;
    }
  
    .banner-section.style-three .mail-box{
      display: none;
    }
  
    .main-header.style-three .sticky-header .menu-right-content .search-btn button{
      color: #fff;
    }
  
    .rtl .main-header .logo-box {
      float: none !important;
      margin-right: 0px;
      margin-left: 0px;
      border-bottom-right-radius: 0px;
      border-bottom-left-radius: 0px;
      padding-right: 0px;
      padding-left: 50px;
    }
  
    .rtl .main-header .menu-right-content{
      float: none;
      padding-right: 50px;
    }
  
    .rtl .menu-area  .main-menu   {
      float: none;
    }
  
  
  }
  
  @media   (min-width: 1100px){

  .main-header .header-top .location-box{
    max-width: 437px !important;
    margin: 0 auto;
  }
  
  
}
 


@media   (max-width: 1201px){

  .main-header .header-top .location-box{
  display: none;
  } 
  
}
  @media only screen and (max-width: 1399px){
  
    .main-header .header-top .location-box .location-carousel{
      padding-right: 0px;
    }
  
    .rtl .main-header .header-top .location-box .location-carousel{
      padding-right: 0px;
      padding-left: 0px;
    }
  
    .main-header .header-top .location-box{
      max-width: 770px;
      margin: 0 auto;
    }
  
    
  
    .main-header .header-top .left-info{
      text-align: center;
    }
  
    .main-header .sticky-header .menu-right-content{
      display: auto;
    }
  
    .main-header .sticky-header .outer-box .menu-area{
      float: inline-start;
    }
    @media   (max-width : 991px ) {
      .main-header .sticky-header .menu-right-content{
        display: none;
      }
    
      .main-header .sticky-header .outer-box .menu-area{
        float:none;
      }
    }
   
  
    #content_block_4 .content-box .inner-box .single-item .inner .icon-box{
      position: relative;
      top: 0px;
      margin-bottom: 15px;
    }
  
    #content_block_4 .content-box .inner-box .single-item .inner{
      padding-left: 0px;
    }
  
    .rtl #content_block_4 .content-box .inner-box .single-item .inner{
      padding-right: 0px;
    }
  
    .rtl .main-header .header-top .location-box{
      max-width: 800px;
    }
  
    .history-section .image-layer{
      display: none;
    }
  
  
  }
  
  
  
  @media only screen and (max-width: 1200px){
  
    .banner-carousel .slide-item.style-two .content-box{
      padding-left: 0px;
    }
  
    .banner-section.style-one .banner-carousel .slide-item{
      min-height: auto;
    }
  
    #content_block_1 .content-box .tab-btns li{
      display: block;
      float: none;
      width: 100%;
      margin-bottom: 10px;
    }
  
    #content_block_1 .content-box .tab-btns li:last-child{
      margin-bottom: 0px;
    }
  
    #content_block_3 .content-box .author-info .signature{
      position: relative;
      display: block;
      margin-top: 20px;
      right: 0px;
    }
  
    .about-section #content_block_3 .content-box{
      padding-right: 30px;
    }
  
    .industries-section .tabs-content{
      margin: 0px;
      margin-top: 30px;
    }
  
    .testimonial-block-one .inner-box .border-shap{
      display: none;
    }
  
    .main-header.style-two .header-lower{
      margin: 0px;
    }
  
    .banner-section.style-two{
      margin: 0px;
    }
  
    .banner-section.style-two .banner-carousel{
      padding: 0px;
    }
  
    .main-header.style-two .header-lower .outer-box{
      border-radius: 0px;
    }
  
    .banner-section.style-two .slide-item .pattern-layer{
      display: none;
    }
  
    .project-block-one .inner-box .content-box{
      padding: 15px 15px;
    }
  
    .project-section .owl-nav{
      right: 10px;
    }
  
    .project-block-one .inner-box .content-box .text h3{
      font-size: 20px;
    }
  
    .pricing-block-one .inner-box a{
      padding: 14px 25px;
    }
  
    .testimonial-style-two .thumb-box{
      display: none;
    }
  
    .contactinfo-section .map-inner{
      border-radius: 0px;
    }
  
    .contactinfo-section .map-inner #contact-google-map{
      width: 100%;
      height: 500px;
      border-radius: 0px;
    }
  
    #content_block_6 .content-box{
      margin-bottom: 40px;
    }
  
    .contactinfo-section{
      padding-bottom: 0px;
    }
  
    .banner-section.style-three .social-box{
      display: none;
    }
  
    .banner-section.style-three .slide-item .pattern-layer .pattern-4{
      display: none;
    }
  
    .banner-section.style-three .owl-nav{
      left: 30px;
    }
  
    .about-style-three .image-layer{
      display: none;
    }
  
    .process-style-two .single-item .inner-box{
      padding-left: 0px;
      padding-right: 15px;
    }
  
    .testimonial-block-three .inner-box .border-shap{
      display: none;
    }
  
    .rtl .about-section #content_block_3 .content-box{
      padding-left: 30px;
    }
  
    .rtl .industries-section .tabs-content{
      margin: 0px;
      margin-top: 30px;
    }
  
    .process-style-two .single-column:first-child .single-item .inner-box{
      padding-left: 30px;
    }
  
    .growth-section .image-box{
      margin-left: 0px;
      margin-right: 0px;
    }
  
    .hiring-section .image-layer{
      display: none;
    }
  
    .hiring-section .left-column .inner-box,
    .hiring-section .right-column .inner-box{
      padding-left: 30px;
      padding-right: 30px;
    }
  
    .service-sidebar .subscribe-widget .subscribe-form button{
      padding: 15px 25px;
    }
  
    .growth-style-two .inner-column .text{
      margin-left: 30px;
    }
  
    .job-details-content .social-box .social-links li{
      margin: 0px 5px;
      margin-bottom: 10px;
    }
  
    .job-details-content .social-box .social-links{
      margin-right: 0px;
    }
  
    .job-details-content .social-box .social-links li a{
      width: 100%;
    }
  
    .blog-details-content .post-share-option .social-box .social-links li{
      margin: 0px 5px;
      margin-bottom: 10px;
    }
  
    .blog-details-content .post-share-option .social-box .social-links li a{
      width: 100%;
    }
  
    .blog-details-content .post-share-option .social-box .social-links{
      margin-right: 0px;
    }
  
    .blog-details-content .nav-btn-box .right-btn{
      padding: 21px 60px 23px 30px;
    }
  
    .blog-details-content .nav-btn-box .left-btn {
      padding: 21px 30px 23px 60px;
    }
  
    .project-block-two .inner-box .content-box .text h3{
      font-size: 18px;
      line-height: 26px;
    }
  
    .protfolio-page .project-block-one .inner-box .content-box{
      padding: 15px 15px;
    }
  
    .portfolio-wide-2 .masonry-item{
      width: 25%;
    }
  
    .single-job-post .job-title{
      width: 40%;
    }
  
    .single-job-post .job-inner .salary-box{
      width: 30%;
    }
  
  
  }
  
  
  
  @media only screen and (min-width: 768px){
     .main-menu .navigation > li > ul,
     .main-menu .navigation > li > ul > li > ul,
     .main-menu .navigation > li > .megamenu{
      display:block !important;
      visibility:hidden;
      opacity:0;
    }
  }
  
  
  
  @media only screen and (max-width: 991px){
  
     .main-menu
    .sticky-header,
    .main-header.style-one .outer-container:before{
      display: none !important;
    }
  
    .menu-area .mobile-nav-toggler {
      display: block;
      margin: 15px 0px;
      margin-right: 30px;
      padding: 10px;
      border: 2px solid #222;
      border-radius: 5px;
      background: #222;
    }
  
    .mobile-menu .navigation > li > a span{
      display: none !important;
    }
  
    .mobile-menu .navigation > li.dropdown > .megamenu li:first-child{
      display: none;
    }
  
    .main-header .header-top .location-box .location-carousel .owl-nav{
      display: none;
    }
  
    .main-header .header-top .location-box .location-carousel p{
      text-align: center;
      margin-bottom: 5px;
    }
  
    .main-header .header-top .location-box .apply-btn{
      width: 100%;
      text-align: center;
    }
  
    .main-header .header-top .left-info{
      padding-bottom: 0px;
    }
  
    .main-header .header-top .location-box{
      padding-bottom: 0px;
    }
  
    .main-header .header-top .right-info{
      padding-top: 13px;
    }
  
    .main-header .logo-box{
      padding-right: 30px;
      padding-left: 30px;
    }
  
    .main-header .menu-right-content{
      padding-right: 30px;
    }
  
    .banner-section.style-one .banner-carousel .slide-item .image-layer{
      width: 100% !important;
    }
  
    .banner-section.style-one .banner-carousel .slide-item .pattern-layer{
      display: none !important;
    }
  
    .banner-section.style-one .banner-carousel .slide-item:before{
      position: absolute;
      content: '';
      background: #fff;
      width: 100%;
      height: 100%;
      left: 0px;
      top: 0px;
      right: 0px;
      opacity: 0.8;
      z-index: 1;
    }
  
    .welcome-section .image-box{
      margin-top: 0px;
      margin-bottom: 50px;
    }
  
    .about-section #content_block_2 .content-box{
      max-width: 550px;
      margin: 0 auto;
    }
  
    .about-section #content_block_3 .content-box{
      padding-left: 30px;
    }
  
    .recruitment-technology .image-box{
      margin: 0px;
      margin-bottom: 50px;
    }
  
    .industries-section .tabs-content .inner-box .content-box{
      padding: 0px 30px;
    }
  
    .process-block-one .inner-box:before{
      display: none;
    }
  
    .process-block-one .inner-box{
      margin-bottom: 50px;
    }
  
    .process-section{
      padding-bottom: 70px;
    }
  
    .news-block-one .inner-box{
      margin-bottom: 30px;
    }
  
    .news-section{
      padding-bottom: 100px;
    }
  
    .sec-title .top-title{
      padding-left: 0;
    }
  
    .sec-title .top-title:before{
      left: 0px;
    }
  
    .sec-title .top-title:after{
      left: 35px;
    }
  
    .awards-section .inner-block{
      margin-bottom: 30px;
    }
  
    .awards-section .image-box{
      max-width: 370px;
      margin: 0 auto;
      margin-bottom: 30px;
    }
  
    .awards-section{
      padding-bottom: 100px;
    }
  
    .footer-top .footer-widget{
      margin: 0px 0px 30px 0px !important;
    }
  
    .footer-top{
      padding-bottom: 50px;
    }
  
    .main-header.style-two .menu-area .mobile-nav-toggler{
      border-color: #fff;
    }
  
    .main-header.style-two .menu-area .mobile-nav-toggler .icon-bar{
      background: #fff;
    }
  
    #content_block_4 .content-box .inner-box .single-item{
      margin-bottom: 30px !important;
    }
  
    #content_block_4 .content-box .inner-box .single-item .inner h3{
      padding-left: 30px;
    }
  
    #content_block_4 .content-box .inner-box .single-item .inner h3:before{
      display: none;
    }
  
    #image_block_1 .image-box .image-2{
      left: 0px;
    }
  
    #image_block_1 .image-box{
      margin-bottom: 40px;
    }
  
    .service-style-two .inner-container .single-item:before{
      display: none;
    }
  
    .service-style-two .inner-container .single-item{
      padding: 50px 30px 0px 30px;
      min-height: auto;
    }
  
    .project-block-one .inner-box .pattern-layer{
      display: none;
    }
  
    .industries-style-two .tab-btn-one .tab-buttons li{
      width: 100%;
      border-right: none;
    }
  
    .industries-style-two .tabs-content-2{
      margin-right: 0px;
      margin-bottom: 40px;
    }
  
    .chooseus-block-one .inner-box{
      margin-bottom: 30px;
    }
  
    .chooseus-section{
      padding-bottom: 100px;
    }
  
    .pricing-section .tab-btn-box{
      position: relative;
      top: 0px;
      margin-bottom: 30px;
    }
  
    .pricing-block-one .inner-box{
      margin-bottom: 30px;
    }
  
    .pricing-section{
      padding-bottom: 100px;
    }
  
    .main-footer .footer-widget .pattern-layer{
      display: none;
    }
  
    .main-footer .callback-widget .widget-content{
      margin-top: 0px;
    }
  
    .main-footer.style-two .footer-top{
      padding-bottom: 70px;
    }
  
    .main-header.style-three .header-lower .outer-box .menu-area{
      display: block;
    }
  
    .main-header.style-three .menu-area .mobile-nav-toggler{
      border-color: #fff;
    }
  
    .main-header.style-three .menu-area .mobile-nav-toggler .icon-bar{
      background: #fff;
    }
  
    .recruitment-technology{
      padding-bottom: 100px;
    }
  
    .process-style-two .single-item .inner-box:before{
      display: none;
    }
  
    .process-style-two .single-column:first-child .single-item .inner-box{
      padding-left: 0px;
    }
  
    .process-style-two .single-item .inner-box{
      padding-left: 30px !important;
      margin-bottom: 30px;
    }
  
    .process-style-two:before{
      height: 100%;
    }
  
    .process-style-two .inner-container{
      padding-bottom: 90px;
    }
  
    .pricing-block-two .inner-box{
      margin-bottom: 30px;
    }
  
    .news-section .sec-title .link{
      position: relative;
      top: 0px;
      margin-top: 15px;
    }
  
    .advice-section .text{
      float: none;
      display: block;
      text-align: center;
      margin-bottom: 15px;
    }
  
    .advice-section .social-links{
      float: none;
      display: block;
      text-align: center;
    }
  
    .main-footer.style-three .footer-top{
      padding-bottom: 30px;
    }
  
    .rtl .mobile-menu .navigation li > a{
      text-align: right;
    }
  
    .rtl .mobile-menu .navigation li > a:before{
      left: inherit;
      right: 0px;
    }
  
    .rtl .mobile-menu .navigation li.dropdown .dropdown-btn{
      right: inherit;
      left: 6px;
    }
  
    .rtl .mobile-menu .nav-logo{
      text-align: right;
    }
  
    .rtl .mobile-menu .close-btn{
      right: 238px;
    }
  
    .rtl .about-section #content_block_2 .content-box{
      margin: 0 auto;
    }
  
    .rtl .about-section #content_block_3 .content-box{
      padding-right: 30px;
    }
  
    .process-style-two .single-column:first-child .single-item .inner-box:after{
      display: none;
    }
  
    .history-section .inner-box{
      padding: 0px !important;
      max-width: 350px;
      margin: 0 auto;
      margin-bottom: 50px;
    }
  
    .history-section .inner-box:before,
    .history-section .inner-box:after,
    .history-section .inner-box .dots-box{
      display: none;
    }
  
    .hiring-strategies .inner-box .funfact-inner .counter-block:before{
      display: none;
    }
  
    .solutions-problems .carousel-box .single-item{
      margin: 30px auto;
    }
  
    .placejob-section .form-inner .job-form .form-group:last-child{
      margin-bottom: 30px;
    }
  
    .faq-section .image-box{
      max-width: 570px;
      margin-bottom: 30px;
    }
  
    .service-details-content .content-three .tab-btns{
      margin-bottom: 30px;
    }
  
    .service-sidebar{
      margin-left: 0px;
      margin-top: 40px;
    }
  
    .growth-style-two .image-column{
      display: none;
    }
  
    .growth-style-two .inner-column .text{
      margin-left: 0px;
      margin-top: 30px;
    }
  
    .growth-style-two .inner-column .text h2{
      color: #001b44;
    }
  
    .findjob-section .search-inner .form-group{
      margin-bottom: 30px;
    }
  
    .single-job-post .job-title{
      width: 100%;
      min-height: 64px;
      margin-bottom: 15px;
    }
  
    .single-job-post .job-inner .salary-box{
      width: 100%;
      margin-top: 0px;
      margin-bottom: 15px;
    }
  
    .single-job-post .job-inner .experience-box{
      width: 100%;
      margin-top: 0px;
      margin-bottom: 15px;
    }
  
    .single-job-post .job-inner .apply-btn{
      width: 100%;
      text-align: left;
    }
  
    .single-job-post .job-title:before,
    .single-job-post .job-inner .salary-box:before{
      display: none;
    }
  
    .job-sidebar{
      margin-left: 0px;
      margin-bottom: 30px;
    }
  
    .service-details-content .content-three .tab-btns li.active-btn:before{
      top: 100%;
      right: 50%;
      margin-right: -15px;
    }
  
    .service-details-content .content-three .tab-btns li{
      margin-bottom: 30px;
    }
  
    .blog-sidebar{
      margin-top: 40px;
    }
  
    .portfolio-wide-2 .masonry-item{
      width: 50%;
    }
  
    .recruitment-technology .image-box img{
      float: none;
      width: 100%;
    }
  
    .banner-section.style-two .banner-carousel:before{
      display: none;
    }
  
    .banner-section.style-two .banner-carousel .slide-item{
      border-radius: 0px;
    }
  
    .locations-section .single-item .inner-box{
      margin-bottom: 30px;
    }
  
    .locations-section{
      padding-bottom: 100px;
    }
  
  
  }
  
    
  
  @media only screen and (max-width: 767px){
  
    .main-header .header-top .location-box{
      padding-left: 0px;
      padding-right: 0px;
    }
  
    .main-header .language{
      margin-left: 15px;
    }
  
    .banner-section.style-one .banner-carousel .slide-item{
      padding: 100px 0px;
    }
  
    .banner-carousel .content-box h1{
      font-size: 40px;
      line-height: 50px;
    }
  
    .clients-section .clients-logo-box .logo-title{
      width: calc(100% - 40px);
      left: 20px;
    }
  
    .sec-title h2{
      font-size: 36px;
      line-height: 44px;
    }
  
    .welcome-section{
      padding: 70px 0px;
    }
  
    .about-section #content_block_3 .content-box{
      padding: 60px 30px;
    }
  
    .service-section .pattern-layer,
    .service-section .anim-icon{
      display: none;
    }
  
    .service-block-one .inner-box .lower-content .overlay-content{
      width: calc(100% - 30px);
      left: 15px;
    }
  
    .service-block-one .inner-box .lower-content{
      padding: 0px 15px;
      margin-bottom: 15px;
    }
  
    .owl-dots,
    .owl-nav{
      display: none !important;
    }
  
    .service-section{
      padding: 70px 0px 40px 0px;
    }
  
    .recruitment-technology{
      padding: 0 0px 40px 0px;
    }
  
    .industries-section{
      padding: 70px 0px;
    }
  
    .process-section{
      padding: 70px 0px 20px 0px;
    }
  
    .team-section,
    .news-section{
      padding: 70px 0px 40px 0px;
    }
  
    .team-block-one{
      max-width: 300px;
      margin: 0 auto;
    }
  
    .news-block-one{
      max-width: 400px;
      margin: 0 auto;
    }
  
    .testimonial-section{
      padding: 70px 0px;
    }
  
    .awards-section,
    .footer-top{
      padding: 70px 0px 40px 0px;
    }
  
    .footer-bottom .copyright{
      float: none;
      display: block;
      margin-bottom: 5px;
      text-align: center;
    }
  
    .footer-bottom .footer-nav{
      float: none;
      display: block;
      text-align: center;
    }
  
    .banner-section.style-two .banner-carousel .slide-item{
      padding: 100px 0px;
    }
  
    .about-style-two{
      padding: 70px 0px;
    }
  
    .about-style-two #image_block_1 .image-box{
      margin: 0px 0px 30px 0px;
    }
  
    .service-style-two .inner-container .single-item .icon-box{
      text-align: left;
    }
  
    .service-style-two .inner-container .single-item{
      padding: 0px 15px 30px 15px;
    }
  
    .service-style-two .inner-container .single-item .link{
      margin-bottom: 0px;
    }
  
    .service-style-two .inner-container .single-item .text{
      margin-top: 15px;
    }
  
    .service-style-two .inner-container{
      padding: 80px 0px 70px 0px;
    }
  
    .project-section{
      padding: 70px 0px;
    }
  
    .industries-style-two{
      padding-bottom: 70px;
    }
  
    .chooseus-section,
    .pricing-section{
      padding: 70px 0px 40px 0px;
    }
  
    .testimonial-style-two{
      padding: 70px 0px;
    }
  
    .clients-style-two .title-inner h2{
      font-size: 36px;
      line-height: 44px;
    }
  
    .clients-style-two .title-inner{
      margin-bottom: 50px;
    }
  
    .clients-style-two{
      padding: 70px 0px;
    }
  
    .contactinfo-section .image-column{
      display: none;
    }
  
    .contactinfo-section{
      padding-top: 70px;
    }
  
    .main-footer.style-two .footer-top{
      padding: 70px 0px 40px 0px;
    }
  
    .footer-bottom .social-links{
      float: none;
      display: block;
      text-align: center;
    }
  
    .banner-section.style-three .slide-item{
      padding: 220px 0px 100px 0px;
    }
  
    .banner-section.style-three .banner-carousel .content-box h1{
      font-size: 50px;
      line-height: 60px;
    }
  
    .about-style-three{
      padding: 70px 0px;
    }
  
    .chooseus-section .title-inner .sec-title, .chooseus-section .title-inner .text{
      float: none;
      display: block;
      width: 100%;
      margin-bottom: 30px;
      margin-top: 0px;
    }
  
    .video-section .video-content .pattern-layer{
      display: none;
    }
  
    .service-section.alternet-2{
      padding-top: 390px;
      padding-bottom: 20px;
    }
  
    .recruitment-technology{
      padding: 0 0px 40px 0px;
    }
  
    .process-style-two .inner-container,
    .team-style-two{
      padding: 70px 0px 40px 0px;
    }
  
    .project-style-two{
      padding-bottom: 70px;
    }
  
    .testimonial-style-three{
      padding: 70px 0px;
    }
  
    .news-section.alternet-2{
      padding-bottom: 40px;
    }
  
    .page-title{
      padding-top: 100px;
    }
  
    .page-title .title-box h1{
      font-size: 40px;
      line-height: 50px;
    }
  
    .page-title .title-box{
      margin-bottom: 60px;
    }
  
    .team-style-three{
      padding: 70px 0px 25px 0px;
    }
  
    .team-style-four{
      padding: 70px 0px 40px 0px;
    }
  
    .hiring-strategies{
      padding: 70px 0px;
    }
  
    .hiring-strategies .inner-box .title-inner{
      padding-left: 30px;
      padding-right: 30px;
    }
  
    .hiring-strategies .inner-box .title-inner h2{
      font-size: 40px;
      line-height: 50px;
    }
  
    .solutions-problems .upper-box .title-inner{
      margin-right: 0px;
    }
  
    .solutions-problems .upper-box .title-inner h2{
      font-size: 36px;
      line-height: 44px;
    }
  
    .solutions-problems .upper-box .title-inner{
      margin-bottom: 30px;
    }
  
    .solutions-problems .upper-box .inner-box .single-item{
      margin-bottom: 30px;
    }
  
    .solutions-problems{
      padding-bottom: 40px;
    }
  
    .solutions-problems .upper-box{
      margin-bottom: 0px;
    }
  
    .growth-section .image-box{
      margin: 0px;
    }
  
    .growth-section{
      padding: 70px 0px;
    }
  
    .growth-section:before{
      height: 100%;
    }
  
    .growth-section .pattern-layer{
      display: none;
    }
  
    .pricing-section.overview-page{
      padding-top: 70px;
    }
  
    .placejob-section .form-inner .job-form .column .form-group:last-child .nice-select{
      margin-bottom: 20px;
    }
  
    .faq-section{
      padding: 70px 0px;
    }
  
    .clients-style-three .clients-inner{
      padding: 0px;
    }
  
    .clients-style-three{
      padding: 70px 0px 40px 0px;
    }
  
    .testimonial-page-section{
      padding-bottom: 20px;
    }
  
    .service-section.service-page .service-block-one{
      max-width: 400px;
      margin: 0 auto 30px auto;
    }
  
    .service-section.service-page{
      padding: 70px 0px 30px 0px;
    }
  
    .hiring-section .left-column, .hiring-section .right-column{
      width: 100%;
    }
  
    .hiring-section .left-column .inner-box{
      max-width: 100%;
    }
  
    .hiring-section .left-column .inner-box, .hiring-section .right-column .inner-box{
      padding: 70px 30px;
    }
  
    .contact-section,
    .service-details{
      padding: 70px 0px;
    }
  
    .contact-section .form-inner .pattern-layer{
      display: none;
    }
  
    .service-details-content .content-two .inner-box .single-column{
      width: 100%;
      margin-bottom: 30px;
      border-right: none;
      box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);
    }
  
    .service-details-content .content-two .inner-box{
      box-shadow: none;
    }
  
    .service-details-content .content-two .inner-box .single-column .overlay-box{
      border-radius: 0px !important;
    }
  
    .service-details-content .content-two .inner-box .single-column .overlay-box .icon-box{
      border-top-right-radius: 0px !important;
    }
  
    .service-details-content .content-four .inner-box .list-item li:last-child{
      margin-bottom: 20px;
    }
  
    .service-details-content .content-four{
      margin-bottom: 40px;
    }
  
    .service-details-content .content-two .inner-box{
      margin-bottom: 30px;
    }
  
    .solutions-problems{
      padding: 70px 0px 40px 0px !important;
    }
  
    .growth-style-two,
    .advantages-section{
      padding: 70px 0px;
    }
  
    .growth-style-two .inner-column .text h2{
      font-size: 40px;
      line-height: 50px;
    }
  
    .growth-style-two #content_block_1 .content-box .inner-box .text{
      padding-bottom: 30px;
    }
  
    .findjob-section,
    .job-details{
      padding: 70px 0px;
    }
  
    .placejob-section{
      padding-bottom: 40px;
    }
  
    .sidebar-page-container{
      padding: 70px 0px;
    }
  
    .news-block-one .inner-box .lower-content .inner .post-info li{
      min-height: 40px;
    }
  
    .sidebar-page-container .news-block-one .inner-box .lower-content .inner{
      margin-top: -30px;
    }
  
    .pagination-wrapper{
      text-align: center;
    }
  
    .news-block-one .inner-box .lower-content .inner h2{
      font-size: 24px;
      line-height: 32px;
    }
  
    .blog-details-content .inner-box .two-column .content-box{
      margin-bottom: 30px;
    }
  
    .blog-details-content .author-box .icon-layer{
      display: none;
    }
  
    .blog-details-content .nav-btn-box .left-btn{
      margin-bottom: 30px;
    }
  
    .blog-details-content .nav-btn-box{
      margin-bottom: 40px;
    }
  
    .protfolio-page{
      padding: 70px 0px;
    }
  
    .portfolio-wide-2 .masonry-item{
      width: 100%;
    }
  
    .locations-section{
      padding: 70px 0px 40px 0px;
    }
  
    #content_block_2 .content-box .inner-box{
      padding: 50px 30px;
    }
  
  }
  
  @media only screen and (max-width: 599px){
   
  
    .main-header .logo-box{
      text-align: center;
    }
  
    .main-header .menu-right-content{
      left: 0px;
      bottom: 7px;
      right: inherit;
      top: auto;
      padding-right: 0px;
      padding-left: 15px;
    }
  
    .main-header .menu-right-content .search-btn button{
      color: #000;
    }
  
    #content_block_1 .content-box .inner-box .list li{
      width: 100%;
      min-height: 65px;
      margin-bottom: 15px;
    }
  
    #content_block_1 .content-box .inner-box .list li:last-child{
      margin-bottom: 0px;
    }
  
    #content_block_3 .content-box .author-text h3{
      font-size: 12px;
      line-height: 1.5;
    }
  
    .industries-section .tabs-content .inner-box .content-box .text{
      margin-right: 0px;
    }
  
    .industries-section .tabs-content .inner-box .content-box .text h2{
      font-size: 30px;
      line-height: 38px;
    }
  
    .testimonial-style-two .testimonial-block-two{
      margin: 0px;
    }
  
    .main-header.style-three .logo-box{
      width: 100%;
    }
  
    .banner-section.style-three .slide-item{
      padding-top: 260px;
    }
  
    .hiring-section .inner-box .icon-box{
      right: 30px;
      bottom: 30px;
    }
  
    .single-job-post .job-header .number{
      float: none;display: block;
      margin-top: 15px;
    }
  
    .single-job-post .job-header .info{
      float: none;
      display: block;
    }
  
    .job-details-content .upper-box .inner-box .company-logo{
      position: relative;
      margin-bottom: 15px;
    }
  
    .job-details-content .upper-box .inner-box{
      padding-left: 0px;
    }
  
    .blog-details-content .comment-box .comment.reply-comment{
      margin-left: 0px;
    }
  
    .menu-area .mobile-nav-toggler{
      margin-right: 15px;
    }
  
    .rtl .main-header .menu-right-content{
      padding: 0px;
    }
  
    .rtl .industries-section .tabs-content .inner-box .content-box .text{
      margin-left: 0px;
    }
  
  }
  
  

  @media (min-width: 600px) and (max-width: 991px)
  {
    .main-header .language .lang-btn
{
  background: #ffffff;
}
.main-header .menu-right-content .theme-btn-one {
  background: #000000;
}
  }
  @media  (min-width: 992px) and  (max-width: 1399px)
{
  #content_block_4 .content-box .inner-box .single-item .inner .icon-box {
  display: none;
}

}

@media  (min-width: 992px) and  (max-width: 1100px){

#content_block_4 .content-box .inner-box .single-item
{
  padding: 15px 30px 5px 30px !important;
  margin-bottom: 10px;
}
}
.container, .container-fluid, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {
  --bs-gutter-x: 0 !important;
}
  @media  (min-width: 992px) and  (max-width: 1600px){
  
.recruitment-technology .image-box img {
  max-width: 161% !important;
  float: right !important;
  right: -22% !important;
  position: relative !important;
  opacity: 0.9;
}
 
}

  @media only screen and (max-width: 499px){
    .icon-box img {
      width: 30px !important;
  }
    .industries-section .tab-btns li{
    position: relative !important;
    display: block !important;
    padding: 0 0px 0 70px!important;
    cursor: pointer!important;
     min-height: 50px!important;
    transition: all 500ms ease!important;
    margin-bottom: 0 !important;
   }
    #content_block_1 .content-box .inner-box .list{
      display: none;
    }
    .main-header .logo-box {
       display: none;
  }
    .main-header .outer-box {
      position: fixed !important;
      width: 100% !important;
      background: white !important;
      top: 0;
  }
  
    #login{
      display: none;
     }
    figure {
      margin:   0 !important;
  }
    .main-header .header-top{
      padding: 0px 15px;
      display: none;
    }
  
    .industries-section .tabs-content .inner-box .content-box{
      position: relative;
      padding: 0px;
    }
  
    .search-popup .search-form fieldset input[type="submit"]{
      position: relative;
      border-radius: 7px;
      display: block;
      width: 100%;
    }
  
    .search-popup .search-form fieldset input[type="search"]{
      padding-right: 30px;
      margin-bottom: 15px;
    }
  
    .banner-carousel .btn-box a{
      margin: 5px 5px;
    }
  
    .feature-section{
      padding: 0px 15px;
    }
  
    #image_block_1 .image-box .video-inner{
      position: relative;
      max-width: 100%;
      margin-bottom: 30px;
    }
  
    .about-style-two #image_block_1 .image-box{
      padding: 0px;
    }
  
    #image_block_1 .image-box .image-2{
      position: relative;
      text-align: center;
      margin-top: 30px;
    }
  
    .industries-style-two .tabs-content-2 .inner-box .content-box{
      padding: 0px 15px;
    }
  
    .industries-style-two .tabs-content-2 .inner-box .content-box .link{
      right: 15px;
      margin-left: 15px;
    }
  
    .industries-style-two .tabs-content-2 .inner-box .content-box .text h2{
      font-size: 24px;
      line-height: 30px;
    }
  
    .clients-style-two .title-inner .btn-box a{
      margin: 5px 5px;
    }
  
    .main-footer.style-two .footer-bottom .copyright .footer-logo{
      position: relative;
      margin-bottom: 15px;
    }
  
    .main-footer.style-two .footer-bottom .copyright{
      padding-left: 0px;
    }
  
    .banner-carousel .content-box h2{
      font-size: 30px;
      line-height: 36px;
    }
  
    .video-section #image_block_1 .image-box .video-inner{
      padding: 150px 0px 140px 0px;
    }
  
    .solutions-problems .carousel-box .single-item .inner-box .lower-content h3{
      font-size: 20px;
      line-height: 28px;
    }
  
    .contact-section .form-inner{
      padding: 50px 30px;
    }
  
    .job-details-content .social-box .social-links li{
      width: 50%;
    }
  
    .job-details-content .social-box .social-links{
      text-align: center;
    }
  
    .job-details-content .social-box .social-links li{
      float: none;
    }
  
    .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box{
      position: relative;
      right: 0px;
      bottom: 0px;
      margin-left: 0px;
    }
  
    .blog-details-content .post-share-option .social-box .social-links{
      text-align: center;
    }
  
    .blog-details-content .post-share-option .social-box .social-links li{
      width: 100%;
      float: none;
    }
  
    .blog-details-content .author-box .signature{
      position: relative;
      top: 0px;
    }
  
    .blog-details-content .author-box{
      padding: 40px 30px 50px 30px;
    }
  
    .blog-details-content .comment-box .comment .comment-inner .comment-info .comment-time{
      position: relative;
      top: 0px;
    }
  
    .blog-details-content .comments-form-area{
      padding: 50px 30px;
    }
  
    .contact-page-section .form-inner{
      padding: 50px 30px;
    }
  
    .locations-section .single-item .inner-box{
      padding-left: 30px;
      padding-right: 30px;
    }
  
  
  
  }
  
  
  @media only screen and (max-width: 399px){
    .service-block-one .inner-box .lower-content .content-box .link a,.service-block-one .inner-box .lower-content .overlay-content a,.process-block-one .inner-box .lower-content a {
   
      font-size: 11px !important;
    }
    #content_block_1 .content-box .inner-box .link a i {
      top: 0;
      font-size: 16px;
    }
    a.theme-btn-two{
      font-size: 12px !important;

    }
    p,.industries-section .tabs-content .inner-box .content-box .text span{
       font-size: 13px !important;
    }
    h5 {
      font-size: 16px !important;
   }
   h3,h2, h4,a{
       font-size: 15px !important;
    }
    #content_block_1 .content-box .tab-btns li {
      padding: 10px 40px 10px 40px;
    }
    #content_block_1 .content-box .inner-box p {
      font-size: 12px;
      text-align: justify;
    }
    #content_block_1 .content-box .tab-btns li h5 {
      font-size: 15px;
    }
    .banner-carousel .content-box h1 br{
      display: none;
    }
    .sec-title p {
      font-size: 12px;
      text-align: justify;
    }
   
    .sec-title h2,
    #content_block_1 .content-box .inner-box h2,
    .clients-style-two .title-inner h2,
    .hiring-strategies .inner-box .title-inner h2,
    .hiring-section .inner-box h2,
    .growth-style-two .inner-column .text h2{
      font-size: 14px;
      line-height: 36px;
    }
  
    .banner-carousel .content-box h1,
    .banner-section.style-three .banner-carousel .content-box h1{
      font-size: 25px;
      line-height: 40px;
    }
  
    .testimonial-block-one .inner-box{
      padding-left: 30px;
    }
  
    .testimonial-block-one .inner-box .author-box{
      padding-left: 0px;
    }
  
    .testimonial-block-one .inner-box .author-box .author-thumb{
      position: relative;
      display: inline-block;
      top: 0px;
      margin-bottom: 15px;
    }
  
    .industries-style-two .tab-btn-two li h3{
      font-size: 15px;
      line-height: 26px;
    }
  
    .rtl .testimonial-block-one .inner-box .author-box{
      padding-right: 0px;
    }
  
    .hiring-strategies .inner-box .funfact-inner .counter-block{
      padding-left: 160px;
    }
  
    .hiring-strategies .inner-box .funfact-inner .counter-block .count-outer{
      left: 30px;
    }
  
    .solutions-problems .carousel-box .single-item .inner-box .lower-content h3{
      position: relative;
      border-radius: 0px;
      border-bottom-left-radius: 10px;
    }
  
    .solutions-problems .carousel-box .single-item .inner-box .lower-content{
      margin-left: 0px;
    }
  
    .solutions-problems .carousel-box .single-item .inner-box .image-box,
    .solutions-problems .carousel-box .single-item .inner-box .image-box img{
      border-bottom-left-radius: 0px;
    }
  
    .placejob-section .form-inner .title-inner{
      padding-left: 0px;
    }
  
    .placejob-section .form-inner .title-inner .icon-box{
      position: relative;
      top: 0px;
      margin-bottom: 15px;
    }
  
    .clients-style-three #image_block_1 .image-box .video-inner{
      padding: 150px 0px 130px 0px;
    }
  
    .service-details-content .content-three .tabs-content .inner-box .text{
      position: relative;
      width: 100%;
      border-radius: 10px;
      margin: 0px;
    }
  
    .service-details-content .content-three .tabs-content .inner-box .image-box{
      margin-bottom: 30px;
    }
  
    .single-job-post .job-header .info li a{
      margin-bottom: 10px;
    }
  
    .single-job-post .job-title{
      padding-left: 0px;
    }
  
    .single-job-post .job-title .company-logo{
      position: relative;
      margin-bottom: 10px;
    }
  
    .single-job-post .job-header .number{
      margin-top: 5px;
    }
  
    .job-details-content .upper-box .inner-box{
      padding-right: 0px;
    }
  
    .sidebar-page-container .news-block-one .inner-box .lower-content .inner{
      padding-left: 30px;
    }
  
    .blog-details-content .post-share-option .tag-list li{
      margin: 3px 2px;
    }
  
    .main-footer .footer-subscribe h3{
      font-size: 18px;
      line-height: 26px;
    }
  
    .error-section .error-content h2{
      font-size: 32px;
      line-height: 40px;
    }
  
  }`, "",{"version":3,"sources":["webpack://./src/CustomCSS/css/responsive.css"],"names":[],"mappings":"AAAA,0BAA0B;;;AAG1B;;IAEI;MACE,gBAAgB;IAClB;;EAEF;;;EAGA;;IAEE;MACE,iBAAiB;IACnB;;EAEF;;;;EAIA;;IAEE;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;KACC;;IAED;MACE,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,cAAc;MACd,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;MAClB,UAAU;MACV,SAAS;MACT,WAAW;IACb;;IAEA;MACE,kBAAkB;MAClB,QAAQ;IACV;;IAEA;MACE,gBAAgB;MAChB,cAAc;MACd,WAAW;IACb;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE;IACF;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE;IACF;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,WAAW;MACX,kBAAkB;IACpB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,sBAAsB;MACtB,iBAAiB;MACjB,gBAAgB;MAChB,+BAA+B;MAC/B,8BAA8B;MAC9B,kBAAkB;MAClB,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,mBAAmB;IACrB;;IAEA;MACE,WAAW;IACb;;;EAGF;;EAEA;;EAEA;IACE,2BAA2B;IAC3B,cAAc;EAChB;;;AAGF;;;;AAIA;;EAEE;EACA,aAAa;EACb;;AAEF;EACE;;IAEE;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;MAClB,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;MAChB,cAAc;IAChB;;;;IAIA;MACE,kBAAkB;IACpB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,mBAAmB;IACrB;IACA;MACE;QACE,aAAa;MACf;;MAEA;QACE,UAAU;MACZ;IACF;;;IAGA;MACE,kBAAkB;MAClB,QAAQ;MACR,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,aAAa;IACf;;;EAGF;;;;EAIA;;IAEE;MACE,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,cAAc;MACd,WAAW;MACX,WAAW;MACX,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;MAClB,cAAc;MACd,gBAAgB;MAChB,UAAU;IACZ;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,gBAAgB;IAClB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,aAAa;MACb,kBAAkB;IACpB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,iBAAiB;MACjB,mBAAmB;IACrB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;MACE,aAAa;IACf;;IAEA;;MAEE,kBAAkB;MAClB,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,4BAA4B;IAC9B;;IAEA;MACE,4BAA4B;IAC9B;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;;;EAGF;;;;EAIA;KACG;;;MAGC,wBAAwB;MACxB,iBAAiB;MACjB,SAAS;IACX;EACF;;;;EAIA;;KAEG;;;MAGC,wBAAwB;IAC1B;;IAEA;MACE,cAAc;MACd,gBAAgB;MAChB,kBAAkB;MAClB,aAAa;MACb,sBAAsB;MACtB,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,kBAAkB;MAClB,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,kBAAkB;IACpB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,kBAAkB;MAClB,WAAW;MACX,gBAAgB;MAChB,WAAW;MACX,YAAY;MACZ,SAAS;MACT,QAAQ;MACR,UAAU;MACV,YAAY;MACZ,UAAU;IACZ;;IAEA;MACE,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,SAAS;IACX;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,cAAc;MACd,mBAAmB;IACrB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,mCAAmC;IACrC;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,8BAA8B;IAChC;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,SAAS;IACX;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,2BAA2B;MAC3B,gBAAgB;IAClB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,WAAW;MACX,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;MACjB,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,kBAAkB;MAClB,QAAQ;MACR,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,6BAA6B;MAC7B,mBAAmB;IACrB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;MAClB,QAAQ;MACR,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,cAAc;MACd,kBAAkB;MAClB,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,cAAc;MACd,kBAAkB;IACpB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,aAAa;MACb,UAAU;IACZ;;IAEA;MACE,cAAc;MACd,SAAS;IACX;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,uBAAuB;MACvB,gBAAgB;MAChB,cAAc;MACd,mBAAmB;IACrB;;IAEA;;;MAGE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,gBAAgB;IAClB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,gBAAgB;MAChB,gBAAgB;IAClB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,WAAW;MACX,gBAAgB;IAClB;;IAEA;;MAEE,aAAa;IACf;;IAEA;MACE,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,SAAS;MACT,UAAU;MACV,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,WAAW;MACX,WAAW;IACb;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,qBAAqB;IACvB;;;EAGF;;;;EAIA;;IAEE;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,wBAAwB;MACxB,UAAU;IACZ;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;;MAEE,aAAa;IACf;;IAEA;MACE,wBAAwB;MACxB,UAAU;IACZ;;IAEA;MACE,iBAAiB;MACjB,mBAAmB;IACrB;;IAEA;;MAEE,wBAAwB;IAC1B;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;;MAEE,0BAA0B;IAC5B;;IAEA;MACE,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;;MAEE,0BAA0B;IAC5B;;IAEA;MACE,WAAW;MACX,cAAc;MACd,kBAAkB;MAClB,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,cAAc;MACd,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;;MAEE,0BAA0B;IAC5B;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,WAAW;MACX,cAAc;MACd,kBAAkB;IACpB;;IAEA;MACE,4BAA4B;IAC9B;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,WAAW;MACX,cAAc;MACd,WAAW;MACX,mBAAmB;MACnB,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,kBAAkB;MAClB,oBAAoB;IACtB;;IAEA;MACE,uBAAuB;IACzB;;IAEA;;MAEE,0BAA0B;IAC5B;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,gBAAgB;MAChB,wBAAwB;IAC1B;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;;MAEE,iBAAiB;IACnB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,WAAW;MACX,mBAAmB;MACnB,kBAAkB;MAClB,0CAA0C;IAC5C;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,6BAA6B;IAC/B;;IAEA;MACE,uCAAuC;IACzC;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,qCAAqC;IACvC;;IAEA;;MAEE,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;;MAEE,iBAAiB;IACnB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,kBAAkB;IACpB;;EAEF;;EAEA;;;IAGE;MACE,kBAAkB;IACpB;;IAEA;MACE,SAAS;MACT,WAAW;MACX,cAAc;MACd,SAAS;MACT,kBAAkB;MAClB,kBAAkB;IACpB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,WAAW;MACX,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW,CAAC,cAAc;MAC1B,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,cAAc;IAChB;;IAEA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,gBAAgB;IAClB;;EAEF;;;;EAIA;;IAEE;;EAEF,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;EACE;EACA;;EAEA;EACA,aAAa;AACf;;AAEA;;AAEA;;AAEA;;EAEE,sCAAsC;EACtC,mBAAmB;AACrB;AACA;AACA;EACE,2BAA2B;AAC7B;EACE;;AAEF;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;;EAEE;IACE;MACE,sBAAsB;EAC1B;IACE;IACA,6BAA6B;IAC7B,yBAAyB;IACzB,+BAA+B;IAC/B,yBAAyB;KACxB,0BAA0B;IAC3B,oCAAoC;IACpC,2BAA2B;GAC5B;IACC;MACE,aAAa;IACf;IACA;OACG,aAAa;EAClB;IACE;MACE,0BAA0B;MAC1B,sBAAsB;MACtB,4BAA4B;MAC5B,MAAM;EACV;;IAEE;MACE,aAAa;KACd;IACD;MACE,sBAAsB;EAC1B;IACE;MACE,iBAAiB;MACjB,aAAa;IACf;;IAEA;MACE,kBAAkB;MAClB,YAAY;IACd;;IAEA;MACE,kBAAkB;MAClB,kBAAkB;MAClB,cAAc;MACd,WAAW;IACb;;IAEA;MACE,mBAAmB;MACnB,mBAAmB;IACrB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,kBAAkB;MAClB,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,WAAW;MACX,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,4BAA4B;IAC9B;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,WAAW;IACb;;IAEA;MACE,kBAAkB;MAClB,QAAQ;IACV;;IAEA;MACE,4BAA4B;IAC9B;;IAEA;MACE,kBAAkB;MAClB,QAAQ;IACV;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;;;;EAIF;;;EAGA;IACE;;MAEE,0BAA0B;IAC5B;IACA;MACE,MAAM;MACN,eAAe;IACjB;IACA;MACE,0BAA0B;;IAE5B;IACA;OACG,0BAA0B;IAC7B;IACA;MACE,0BAA0B;GAC7B;GACA;OACI,0BAA0B;IAC7B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,eAAe;MACf,mBAAmB;IACrB;IACA;MACE,eAAe;IACjB;IACA;MACE,aAAa;IACf;IACA;MACE,eAAe;MACf,mBAAmB;IACrB;;IAEA;;;;;;MAME,eAAe;MACf,iBAAiB;IACnB;;IAEA;;MAEE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,qBAAqB;MACrB,QAAQ;MACR,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,kBAAkB;MAClB,kBAAkB;MAClB,+BAA+B;IACjC;;IAEA;MACE,gBAAgB;IAClB;;IAEA;;MAEE,8BAA8B;IAChC;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,QAAQ;MACR,mBAAmB;IACrB;;IAEA;MACE,4BAA4B;IAC9B;;IAEA;MACE,kBAAkB;MAClB,WAAW;MACX,mBAAmB;MACnB,WAAW;IACb;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,mBAAmB;IACrB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;EAEF","sourcesContent":["/*  Theme Responsive Css */\n\n\n@media only screen and (max-width: 5000px){\n  \n    .boxed_wrapper{\n      overflow: hidden;\n    }\n  \n  }\n  \n  \n  @media only screen and (max-width: 1849px){\n  \n    .main-header.style-two .logo-box{\n      margin-right: 0px;\n    }\n  \n  }\n  \n  \n  \n  @media only screen and (max-width: 991px){\n  \n    .main-header .header-top .location-box{\n      border-left: none;\n      border-right: none;\n    }\n  \n    .main-header .header-top .right-info{\n     }\n  \n    .main-header .outer-box{\n      position: relative;\n    }\n  \n    .main-header .outer-box .menu-area{\n      float: none;\n      display: block;\n      text-align: center;\n    }\n  \n    .main-header .logo-box{\n      float: none;\n      margin-right: 0px;\n      border-radius: 0px;\n    }\n  \n    .main-header .menu-right-content{\n      position: absolute;\n      right: 0px;\n      top: 21px;\n      margin: 0px;\n    }\n  \n    .main-header .sticky-header .menu-right-content{\n      position: relative;\n      top: 0px;\n    }\n  \n    .main-header  .main-menu  {\n      max-width: 920px;\n      margin: 0 auto;\n      float: none;\n    }\n  \n    .main-header.onepage  .main-menu   {\n      max-width: 650px;\n    }\n  \n    .main-header .logo-box{\n      text-align: left;\n    }\n  \n    .main-header .menu-right-content .theme-btn-one{\n      background: #002c5d;\n    }\n  \n    .main-header .menu-right-content .theme-btn-one:hover{\n      color: #002c5d !important;\n    }\n  \n    .main-header .menu-right-content .theme-btn-one:after{\n      background: #fff;\n    }\n  \n    .main-header .menu-right-content .search-btn button{\n      color: #fff\n    }\n  \n    .main-header .menu-right-content .search-btn button:hover{\n      color: #002c5d !important;\n    }\n  \n    .main-header .sticky-header .menu-right-content .search-btn button{\n      color: #000\n    }\n  \n    .sticky-header .logo-box{\n      display: none;\n    }\n  \n    .main-header .sticky-header .outer-box .menu-area{\n      float: left;\n      padding-left: 50px;\n    }\n  \n    .main-header.style-two .sticky-header .menu-right-content .search-btn button{\n      color: #fff;\n    }\n  \n    .main-header.style-three .header-lower .outer-box .menu-area{\n      width: 100%;\n    }\n  \n    .banner-section.style-three .mail-box{\n      display: none;\n    }\n  \n    .main-header.style-three .sticky-header .menu-right-content .search-btn button{\n      color: #fff;\n    }\n  \n    .rtl .main-header .logo-box {\n      float: none !important;\n      margin-right: 0px;\n      margin-left: 0px;\n      border-bottom-right-radius: 0px;\n      border-bottom-left-radius: 0px;\n      padding-right: 0px;\n      padding-left: 50px;\n    }\n  \n    .rtl .main-header .menu-right-content{\n      float: none;\n      padding-right: 50px;\n    }\n  \n    .rtl .menu-area  .main-menu   {\n      float: none;\n    }\n  \n  \n  }\n  \n  @media   (min-width: 1100px){\n\n  .main-header .header-top .location-box{\n    max-width: 437px !important;\n    margin: 0 auto;\n  }\n  \n  \n}\n \n\n\n@media   (max-width: 1201px){\n\n  .main-header .header-top .location-box{\n  display: none;\n  } \n  \n}\n  @media only screen and (max-width: 1399px){\n  \n    .main-header .header-top .location-box .location-carousel{\n      padding-right: 0px;\n    }\n  \n    .rtl .main-header .header-top .location-box .location-carousel{\n      padding-right: 0px;\n      padding-left: 0px;\n    }\n  \n    .main-header .header-top .location-box{\n      max-width: 770px;\n      margin: 0 auto;\n    }\n  \n    \n  \n    .main-header .header-top .left-info{\n      text-align: center;\n    }\n  \n    .main-header .sticky-header .menu-right-content{\n      display: auto;\n    }\n  \n    .main-header .sticky-header .outer-box .menu-area{\n      float: inline-start;\n    }\n    @media   (max-width : 991px ) {\n      .main-header .sticky-header .menu-right-content{\n        display: none;\n      }\n    \n      .main-header .sticky-header .outer-box .menu-area{\n        float:none;\n      }\n    }\n   \n  \n    #content_block_4 .content-box .inner-box .single-item .inner .icon-box{\n      position: relative;\n      top: 0px;\n      margin-bottom: 15px;\n    }\n  \n    #content_block_4 .content-box .inner-box .single-item .inner{\n      padding-left: 0px;\n    }\n  \n    .rtl #content_block_4 .content-box .inner-box .single-item .inner{\n      padding-right: 0px;\n    }\n  \n    .rtl .main-header .header-top .location-box{\n      max-width: 800px;\n    }\n  \n    .history-section .image-layer{\n      display: none;\n    }\n  \n  \n  }\n  \n  \n  \n  @media only screen and (max-width: 1200px){\n  \n    .banner-carousel .slide-item.style-two .content-box{\n      padding-left: 0px;\n    }\n  \n    .banner-section.style-one .banner-carousel .slide-item{\n      min-height: auto;\n    }\n  \n    #content_block_1 .content-box .tab-btns li{\n      display: block;\n      float: none;\n      width: 100%;\n      margin-bottom: 10px;\n    }\n  \n    #content_block_1 .content-box .tab-btns li:last-child{\n      margin-bottom: 0px;\n    }\n  \n    #content_block_3 .content-box .author-info .signature{\n      position: relative;\n      display: block;\n      margin-top: 20px;\n      right: 0px;\n    }\n  \n    .about-section #content_block_3 .content-box{\n      padding-right: 30px;\n    }\n  \n    .industries-section .tabs-content{\n      margin: 0px;\n      margin-top: 30px;\n    }\n  \n    .testimonial-block-one .inner-box .border-shap{\n      display: none;\n    }\n  \n    .main-header.style-two .header-lower{\n      margin: 0px;\n    }\n  \n    .banner-section.style-two{\n      margin: 0px;\n    }\n  \n    .banner-section.style-two .banner-carousel{\n      padding: 0px;\n    }\n  \n    .main-header.style-two .header-lower .outer-box{\n      border-radius: 0px;\n    }\n  \n    .banner-section.style-two .slide-item .pattern-layer{\n      display: none;\n    }\n  \n    .project-block-one .inner-box .content-box{\n      padding: 15px 15px;\n    }\n  \n    .project-section .owl-nav{\n      right: 10px;\n    }\n  \n    .project-block-one .inner-box .content-box .text h3{\n      font-size: 20px;\n    }\n  \n    .pricing-block-one .inner-box a{\n      padding: 14px 25px;\n    }\n  \n    .testimonial-style-two .thumb-box{\n      display: none;\n    }\n  \n    .contactinfo-section .map-inner{\n      border-radius: 0px;\n    }\n  \n    .contactinfo-section .map-inner #contact-google-map{\n      width: 100%;\n      height: 500px;\n      border-radius: 0px;\n    }\n  \n    #content_block_6 .content-box{\n      margin-bottom: 40px;\n    }\n  \n    .contactinfo-section{\n      padding-bottom: 0px;\n    }\n  \n    .banner-section.style-three .social-box{\n      display: none;\n    }\n  \n    .banner-section.style-three .slide-item .pattern-layer .pattern-4{\n      display: none;\n    }\n  \n    .banner-section.style-three .owl-nav{\n      left: 30px;\n    }\n  \n    .about-style-three .image-layer{\n      display: none;\n    }\n  \n    .process-style-two .single-item .inner-box{\n      padding-left: 0px;\n      padding-right: 15px;\n    }\n  \n    .testimonial-block-three .inner-box .border-shap{\n      display: none;\n    }\n  \n    .rtl .about-section #content_block_3 .content-box{\n      padding-left: 30px;\n    }\n  \n    .rtl .industries-section .tabs-content{\n      margin: 0px;\n      margin-top: 30px;\n    }\n  \n    .process-style-two .single-column:first-child .single-item .inner-box{\n      padding-left: 30px;\n    }\n  \n    .growth-section .image-box{\n      margin-left: 0px;\n      margin-right: 0px;\n    }\n  \n    .hiring-section .image-layer{\n      display: none;\n    }\n  \n    .hiring-section .left-column .inner-box,\n    .hiring-section .right-column .inner-box{\n      padding-left: 30px;\n      padding-right: 30px;\n    }\n  \n    .service-sidebar .subscribe-widget .subscribe-form button{\n      padding: 15px 25px;\n    }\n  \n    .growth-style-two .inner-column .text{\n      margin-left: 30px;\n    }\n  \n    .job-details-content .social-box .social-links li{\n      margin: 0px 5px;\n      margin-bottom: 10px;\n    }\n  \n    .job-details-content .social-box .social-links{\n      margin-right: 0px;\n    }\n  \n    .job-details-content .social-box .social-links li a{\n      width: 100%;\n    }\n  \n    .blog-details-content .post-share-option .social-box .social-links li{\n      margin: 0px 5px;\n      margin-bottom: 10px;\n    }\n  \n    .blog-details-content .post-share-option .social-box .social-links li a{\n      width: 100%;\n    }\n  \n    .blog-details-content .post-share-option .social-box .social-links{\n      margin-right: 0px;\n    }\n  \n    .blog-details-content .nav-btn-box .right-btn{\n      padding: 21px 60px 23px 30px;\n    }\n  \n    .blog-details-content .nav-btn-box .left-btn {\n      padding: 21px 30px 23px 60px;\n    }\n  \n    .project-block-two .inner-box .content-box .text h3{\n      font-size: 18px;\n      line-height: 26px;\n    }\n  \n    .protfolio-page .project-block-one .inner-box .content-box{\n      padding: 15px 15px;\n    }\n  \n    .portfolio-wide-2 .masonry-item{\n      width: 25%;\n    }\n  \n    .single-job-post .job-title{\n      width: 40%;\n    }\n  \n    .single-job-post .job-inner .salary-box{\n      width: 30%;\n    }\n  \n  \n  }\n  \n  \n  \n  @media only screen and (min-width: 768px){\n     .main-menu .navigation > li > ul,\n     .main-menu .navigation > li > ul > li > ul,\n     .main-menu .navigation > li > .megamenu{\n      display:block !important;\n      visibility:hidden;\n      opacity:0;\n    }\n  }\n  \n  \n  \n  @media only screen and (max-width: 991px){\n  \n     .main-menu\n    .sticky-header,\n    .main-header.style-one .outer-container:before{\n      display: none !important;\n    }\n  \n    .menu-area .mobile-nav-toggler {\n      display: block;\n      margin: 15px 0px;\n      margin-right: 30px;\n      padding: 10px;\n      border: 2px solid #222;\n      border-radius: 5px;\n      background: #222;\n    }\n  \n    .mobile-menu .navigation > li > a span{\n      display: none !important;\n    }\n  \n    .mobile-menu .navigation > li.dropdown > .megamenu li:first-child{\n      display: none;\n    }\n  \n    .main-header .header-top .location-box .location-carousel .owl-nav{\n      display: none;\n    }\n  \n    .main-header .header-top .location-box .location-carousel p{\n      text-align: center;\n      margin-bottom: 5px;\n    }\n  \n    .main-header .header-top .location-box .apply-btn{\n      width: 100%;\n      text-align: center;\n    }\n  \n    .main-header .header-top .left-info{\n      padding-bottom: 0px;\n    }\n  \n    .main-header .header-top .location-box{\n      padding-bottom: 0px;\n    }\n  \n    .main-header .header-top .right-info{\n      padding-top: 13px;\n    }\n  \n    .main-header .logo-box{\n      padding-right: 30px;\n      padding-left: 30px;\n    }\n  \n    .main-header .menu-right-content{\n      padding-right: 30px;\n    }\n  \n    .banner-section.style-one .banner-carousel .slide-item .image-layer{\n      width: 100% !important;\n    }\n  \n    .banner-section.style-one .banner-carousel .slide-item .pattern-layer{\n      display: none !important;\n    }\n  \n    .banner-section.style-one .banner-carousel .slide-item:before{\n      position: absolute;\n      content: '';\n      background: #fff;\n      width: 100%;\n      height: 100%;\n      left: 0px;\n      top: 0px;\n      right: 0px;\n      opacity: 0.8;\n      z-index: 1;\n    }\n  \n    .welcome-section .image-box{\n      margin-top: 0px;\n      margin-bottom: 50px;\n    }\n  \n    .about-section #content_block_2 .content-box{\n      max-width: 550px;\n      margin: 0 auto;\n    }\n  \n    .about-section #content_block_3 .content-box{\n      padding-left: 30px;\n    }\n  \n    .recruitment-technology .image-box{\n      margin: 0px;\n      margin-bottom: 50px;\n    }\n  \n    .industries-section .tabs-content .inner-box .content-box{\n      padding: 0px 30px;\n    }\n  \n    .process-block-one .inner-box:before{\n      display: none;\n    }\n  \n    .process-block-one .inner-box{\n      margin-bottom: 50px;\n    }\n  \n    .process-section{\n      padding-bottom: 70px;\n    }\n  \n    .news-block-one .inner-box{\n      margin-bottom: 30px;\n    }\n  \n    .news-section{\n      padding-bottom: 100px;\n    }\n  \n    .sec-title .top-title{\n      padding-left: 0;\n    }\n  \n    .sec-title .top-title:before{\n      left: 0px;\n    }\n  \n    .sec-title .top-title:after{\n      left: 35px;\n    }\n  \n    .awards-section .inner-block{\n      margin-bottom: 30px;\n    }\n  \n    .awards-section .image-box{\n      max-width: 370px;\n      margin: 0 auto;\n      margin-bottom: 30px;\n    }\n  \n    .awards-section{\n      padding-bottom: 100px;\n    }\n  \n    .footer-top .footer-widget{\n      margin: 0px 0px 30px 0px !important;\n    }\n  \n    .footer-top{\n      padding-bottom: 50px;\n    }\n  \n    .main-header.style-two .menu-area .mobile-nav-toggler{\n      border-color: #fff;\n    }\n  \n    .main-header.style-two .menu-area .mobile-nav-toggler .icon-bar{\n      background: #fff;\n    }\n  \n    #content_block_4 .content-box .inner-box .single-item{\n      margin-bottom: 30px !important;\n    }\n  \n    #content_block_4 .content-box .inner-box .single-item .inner h3{\n      padding-left: 30px;\n    }\n  \n    #content_block_4 .content-box .inner-box .single-item .inner h3:before{\n      display: none;\n    }\n  \n    #image_block_1 .image-box .image-2{\n      left: 0px;\n    }\n  \n    #image_block_1 .image-box{\n      margin-bottom: 40px;\n    }\n  \n    .service-style-two .inner-container .single-item:before{\n      display: none;\n    }\n  \n    .service-style-two .inner-container .single-item{\n      padding: 50px 30px 0px 30px;\n      min-height: auto;\n    }\n  \n    .project-block-one .inner-box .pattern-layer{\n      display: none;\n    }\n  \n    .industries-style-two .tab-btn-one .tab-buttons li{\n      width: 100%;\n      border-right: none;\n    }\n  \n    .industries-style-two .tabs-content-2{\n      margin-right: 0px;\n      margin-bottom: 40px;\n    }\n  \n    .chooseus-block-one .inner-box{\n      margin-bottom: 30px;\n    }\n  \n    .chooseus-section{\n      padding-bottom: 100px;\n    }\n  \n    .pricing-section .tab-btn-box{\n      position: relative;\n      top: 0px;\n      margin-bottom: 30px;\n    }\n  \n    .pricing-block-one .inner-box{\n      margin-bottom: 30px;\n    }\n  \n    .pricing-section{\n      padding-bottom: 100px;\n    }\n  \n    .main-footer .footer-widget .pattern-layer{\n      display: none;\n    }\n  \n    .main-footer .callback-widget .widget-content{\n      margin-top: 0px;\n    }\n  \n    .main-footer.style-two .footer-top{\n      padding-bottom: 70px;\n    }\n  \n    .main-header.style-three .header-lower .outer-box .menu-area{\n      display: block;\n    }\n  \n    .main-header.style-three .menu-area .mobile-nav-toggler{\n      border-color: #fff;\n    }\n  \n    .main-header.style-three .menu-area .mobile-nav-toggler .icon-bar{\n      background: #fff;\n    }\n  \n    .recruitment-technology{\n      padding-bottom: 100px;\n    }\n  \n    .process-style-two .single-item .inner-box:before{\n      display: none;\n    }\n  \n    .process-style-two .single-column:first-child .single-item .inner-box{\n      padding-left: 0px;\n    }\n  \n    .process-style-two .single-item .inner-box{\n      padding-left: 30px !important;\n      margin-bottom: 30px;\n    }\n  \n    .process-style-two:before{\n      height: 100%;\n    }\n  \n    .process-style-two .inner-container{\n      padding-bottom: 90px;\n    }\n  \n    .pricing-block-two .inner-box{\n      margin-bottom: 30px;\n    }\n  \n    .news-section .sec-title .link{\n      position: relative;\n      top: 0px;\n      margin-top: 15px;\n    }\n  \n    .advice-section .text{\n      float: none;\n      display: block;\n      text-align: center;\n      margin-bottom: 15px;\n    }\n  \n    .advice-section .social-links{\n      float: none;\n      display: block;\n      text-align: center;\n    }\n  \n    .main-footer.style-three .footer-top{\n      padding-bottom: 30px;\n    }\n  \n    .rtl .mobile-menu .navigation li > a{\n      text-align: right;\n    }\n  \n    .rtl .mobile-menu .navigation li > a:before{\n      left: inherit;\n      right: 0px;\n    }\n  \n    .rtl .mobile-menu .navigation li.dropdown .dropdown-btn{\n      right: inherit;\n      left: 6px;\n    }\n  \n    .rtl .mobile-menu .nav-logo{\n      text-align: right;\n    }\n  \n    .rtl .mobile-menu .close-btn{\n      right: 238px;\n    }\n  \n    .rtl .about-section #content_block_2 .content-box{\n      margin: 0 auto;\n    }\n  \n    .rtl .about-section #content_block_3 .content-box{\n      padding-right: 30px;\n    }\n  \n    .process-style-two .single-column:first-child .single-item .inner-box:after{\n      display: none;\n    }\n  \n    .history-section .inner-box{\n      padding: 0px !important;\n      max-width: 350px;\n      margin: 0 auto;\n      margin-bottom: 50px;\n    }\n  \n    .history-section .inner-box:before,\n    .history-section .inner-box:after,\n    .history-section .inner-box .dots-box{\n      display: none;\n    }\n  \n    .hiring-strategies .inner-box .funfact-inner .counter-block:before{\n      display: none;\n    }\n  \n    .solutions-problems .carousel-box .single-item{\n      margin: 30px auto;\n    }\n  \n    .placejob-section .form-inner .job-form .form-group:last-child{\n      margin-bottom: 30px;\n    }\n  \n    .faq-section .image-box{\n      max-width: 570px;\n      margin-bottom: 30px;\n    }\n  \n    .service-details-content .content-three .tab-btns{\n      margin-bottom: 30px;\n    }\n  \n    .service-sidebar{\n      margin-left: 0px;\n      margin-top: 40px;\n    }\n  \n    .growth-style-two .image-column{\n      display: none;\n    }\n  \n    .growth-style-two .inner-column .text{\n      margin-left: 0px;\n      margin-top: 30px;\n    }\n  \n    .growth-style-two .inner-column .text h2{\n      color: #001b44;\n    }\n  \n    .findjob-section .search-inner .form-group{\n      margin-bottom: 30px;\n    }\n  \n    .single-job-post .job-title{\n      width: 100%;\n      min-height: 64px;\n      margin-bottom: 15px;\n    }\n  \n    .single-job-post .job-inner .salary-box{\n      width: 100%;\n      margin-top: 0px;\n      margin-bottom: 15px;\n    }\n  \n    .single-job-post .job-inner .experience-box{\n      width: 100%;\n      margin-top: 0px;\n      margin-bottom: 15px;\n    }\n  \n    .single-job-post .job-inner .apply-btn{\n      width: 100%;\n      text-align: left;\n    }\n  \n    .single-job-post .job-title:before,\n    .single-job-post .job-inner .salary-box:before{\n      display: none;\n    }\n  \n    .job-sidebar{\n      margin-left: 0px;\n      margin-bottom: 30px;\n    }\n  \n    .service-details-content .content-three .tab-btns li.active-btn:before{\n      top: 100%;\n      right: 50%;\n      margin-right: -15px;\n    }\n  \n    .service-details-content .content-three .tab-btns li{\n      margin-bottom: 30px;\n    }\n  \n    .blog-sidebar{\n      margin-top: 40px;\n    }\n  \n    .portfolio-wide-2 .masonry-item{\n      width: 50%;\n    }\n  \n    .recruitment-technology .image-box img{\n      float: none;\n      width: 100%;\n    }\n  \n    .banner-section.style-two .banner-carousel:before{\n      display: none;\n    }\n  \n    .banner-section.style-two .banner-carousel .slide-item{\n      border-radius: 0px;\n    }\n  \n    .locations-section .single-item .inner-box{\n      margin-bottom: 30px;\n    }\n  \n    .locations-section{\n      padding-bottom: 100px;\n    }\n  \n  \n  }\n  \n    \n  \n  @media only screen and (max-width: 767px){\n  \n    .main-header .header-top .location-box{\n      padding-left: 0px;\n      padding-right: 0px;\n    }\n  \n    .main-header .language{\n      margin-left: 15px;\n    }\n  \n    .banner-section.style-one .banner-carousel .slide-item{\n      padding: 100px 0px;\n    }\n  \n    .banner-carousel .content-box h1{\n      font-size: 40px;\n      line-height: 50px;\n    }\n  \n    .clients-section .clients-logo-box .logo-title{\n      width: calc(100% - 40px);\n      left: 20px;\n    }\n  \n    .sec-title h2{\n      font-size: 36px;\n      line-height: 44px;\n    }\n  \n    .welcome-section{\n      padding: 70px 0px;\n    }\n  \n    .about-section #content_block_3 .content-box{\n      padding: 60px 30px;\n    }\n  \n    .service-section .pattern-layer,\n    .service-section .anim-icon{\n      display: none;\n    }\n  \n    .service-block-one .inner-box .lower-content .overlay-content{\n      width: calc(100% - 30px);\n      left: 15px;\n    }\n  \n    .service-block-one .inner-box .lower-content{\n      padding: 0px 15px;\n      margin-bottom: 15px;\n    }\n  \n    .owl-dots,\n    .owl-nav{\n      display: none !important;\n    }\n  \n    .service-section{\n      padding: 70px 0px 40px 0px;\n    }\n  \n    .recruitment-technology{\n      padding: 0 0px 40px 0px;\n    }\n  \n    .industries-section{\n      padding: 70px 0px;\n    }\n  \n    .process-section{\n      padding: 70px 0px 20px 0px;\n    }\n  \n    .team-section,\n    .news-section{\n      padding: 70px 0px 40px 0px;\n    }\n  \n    .team-block-one{\n      max-width: 300px;\n      margin: 0 auto;\n    }\n  \n    .news-block-one{\n      max-width: 400px;\n      margin: 0 auto;\n    }\n  \n    .testimonial-section{\n      padding: 70px 0px;\n    }\n  \n    .awards-section,\n    .footer-top{\n      padding: 70px 0px 40px 0px;\n    }\n  \n    .footer-bottom .copyright{\n      float: none;\n      display: block;\n      margin-bottom: 5px;\n      text-align: center;\n    }\n  \n    .footer-bottom .footer-nav{\n      float: none;\n      display: block;\n      text-align: center;\n    }\n  \n    .banner-section.style-two .banner-carousel .slide-item{\n      padding: 100px 0px;\n    }\n  \n    .about-style-two{\n      padding: 70px 0px;\n    }\n  \n    .about-style-two #image_block_1 .image-box{\n      margin: 0px 0px 30px 0px;\n    }\n  \n    .service-style-two .inner-container .single-item .icon-box{\n      text-align: left;\n    }\n  \n    .service-style-two .inner-container .single-item{\n      padding: 0px 15px 30px 15px;\n    }\n  \n    .service-style-two .inner-container .single-item .link{\n      margin-bottom: 0px;\n    }\n  \n    .service-style-two .inner-container .single-item .text{\n      margin-top: 15px;\n    }\n  \n    .service-style-two .inner-container{\n      padding: 80px 0px 70px 0px;\n    }\n  \n    .project-section{\n      padding: 70px 0px;\n    }\n  \n    .industries-style-two{\n      padding-bottom: 70px;\n    }\n  \n    .chooseus-section,\n    .pricing-section{\n      padding: 70px 0px 40px 0px;\n    }\n  \n    .testimonial-style-two{\n      padding: 70px 0px;\n    }\n  \n    .clients-style-two .title-inner h2{\n      font-size: 36px;\n      line-height: 44px;\n    }\n  \n    .clients-style-two .title-inner{\n      margin-bottom: 50px;\n    }\n  \n    .clients-style-two{\n      padding: 70px 0px;\n    }\n  \n    .contactinfo-section .image-column{\n      display: none;\n    }\n  \n    .contactinfo-section{\n      padding-top: 70px;\n    }\n  \n    .main-footer.style-two .footer-top{\n      padding: 70px 0px 40px 0px;\n    }\n  \n    .footer-bottom .social-links{\n      float: none;\n      display: block;\n      text-align: center;\n    }\n  \n    .banner-section.style-three .slide-item{\n      padding: 220px 0px 100px 0px;\n    }\n  \n    .banner-section.style-three .banner-carousel .content-box h1{\n      font-size: 50px;\n      line-height: 60px;\n    }\n  \n    .about-style-three{\n      padding: 70px 0px;\n    }\n  \n    .chooseus-section .title-inner .sec-title, .chooseus-section .title-inner .text{\n      float: none;\n      display: block;\n      width: 100%;\n      margin-bottom: 30px;\n      margin-top: 0px;\n    }\n  \n    .video-section .video-content .pattern-layer{\n      display: none;\n    }\n  \n    .service-section.alternet-2{\n      padding-top: 390px;\n      padding-bottom: 20px;\n    }\n  \n    .recruitment-technology{\n      padding: 0 0px 40px 0px;\n    }\n  \n    .process-style-two .inner-container,\n    .team-style-two{\n      padding: 70px 0px 40px 0px;\n    }\n  \n    .project-style-two{\n      padding-bottom: 70px;\n    }\n  \n    .testimonial-style-three{\n      padding: 70px 0px;\n    }\n  \n    .news-section.alternet-2{\n      padding-bottom: 40px;\n    }\n  \n    .page-title{\n      padding-top: 100px;\n    }\n  \n    .page-title .title-box h1{\n      font-size: 40px;\n      line-height: 50px;\n    }\n  \n    .page-title .title-box{\n      margin-bottom: 60px;\n    }\n  \n    .team-style-three{\n      padding: 70px 0px 25px 0px;\n    }\n  \n    .team-style-four{\n      padding: 70px 0px 40px 0px;\n    }\n  \n    .hiring-strategies{\n      padding: 70px 0px;\n    }\n  \n    .hiring-strategies .inner-box .title-inner{\n      padding-left: 30px;\n      padding-right: 30px;\n    }\n  \n    .hiring-strategies .inner-box .title-inner h2{\n      font-size: 40px;\n      line-height: 50px;\n    }\n  \n    .solutions-problems .upper-box .title-inner{\n      margin-right: 0px;\n    }\n  \n    .solutions-problems .upper-box .title-inner h2{\n      font-size: 36px;\n      line-height: 44px;\n    }\n  \n    .solutions-problems .upper-box .title-inner{\n      margin-bottom: 30px;\n    }\n  \n    .solutions-problems .upper-box .inner-box .single-item{\n      margin-bottom: 30px;\n    }\n  \n    .solutions-problems{\n      padding-bottom: 40px;\n    }\n  \n    .solutions-problems .upper-box{\n      margin-bottom: 0px;\n    }\n  \n    .growth-section .image-box{\n      margin: 0px;\n    }\n  \n    .growth-section{\n      padding: 70px 0px;\n    }\n  \n    .growth-section:before{\n      height: 100%;\n    }\n  \n    .growth-section .pattern-layer{\n      display: none;\n    }\n  \n    .pricing-section.overview-page{\n      padding-top: 70px;\n    }\n  \n    .placejob-section .form-inner .job-form .column .form-group:last-child .nice-select{\n      margin-bottom: 20px;\n    }\n  \n    .faq-section{\n      padding: 70px 0px;\n    }\n  \n    .clients-style-three .clients-inner{\n      padding: 0px;\n    }\n  \n    .clients-style-three{\n      padding: 70px 0px 40px 0px;\n    }\n  \n    .testimonial-page-section{\n      padding-bottom: 20px;\n    }\n  \n    .service-section.service-page .service-block-one{\n      max-width: 400px;\n      margin: 0 auto 30px auto;\n    }\n  \n    .service-section.service-page{\n      padding: 70px 0px 30px 0px;\n    }\n  \n    .hiring-section .left-column, .hiring-section .right-column{\n      width: 100%;\n    }\n  \n    .hiring-section .left-column .inner-box{\n      max-width: 100%;\n    }\n  \n    .hiring-section .left-column .inner-box, .hiring-section .right-column .inner-box{\n      padding: 70px 30px;\n    }\n  \n    .contact-section,\n    .service-details{\n      padding: 70px 0px;\n    }\n  \n    .contact-section .form-inner .pattern-layer{\n      display: none;\n    }\n  \n    .service-details-content .content-two .inner-box .single-column{\n      width: 100%;\n      margin-bottom: 30px;\n      border-right: none;\n      box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);\n    }\n  \n    .service-details-content .content-two .inner-box{\n      box-shadow: none;\n    }\n  \n    .service-details-content .content-two .inner-box .single-column .overlay-box{\n      border-radius: 0px !important;\n    }\n  \n    .service-details-content .content-two .inner-box .single-column .overlay-box .icon-box{\n      border-top-right-radius: 0px !important;\n    }\n  \n    .service-details-content .content-four .inner-box .list-item li:last-child{\n      margin-bottom: 20px;\n    }\n  \n    .service-details-content .content-four{\n      margin-bottom: 40px;\n    }\n  \n    .service-details-content .content-two .inner-box{\n      margin-bottom: 30px;\n    }\n  \n    .solutions-problems{\n      padding: 70px 0px 40px 0px !important;\n    }\n  \n    .growth-style-two,\n    .advantages-section{\n      padding: 70px 0px;\n    }\n  \n    .growth-style-two .inner-column .text h2{\n      font-size: 40px;\n      line-height: 50px;\n    }\n  \n    .growth-style-two #content_block_1 .content-box .inner-box .text{\n      padding-bottom: 30px;\n    }\n  \n    .findjob-section,\n    .job-details{\n      padding: 70px 0px;\n    }\n  \n    .placejob-section{\n      padding-bottom: 40px;\n    }\n  \n    .sidebar-page-container{\n      padding: 70px 0px;\n    }\n  \n    .news-block-one .inner-box .lower-content .inner .post-info li{\n      min-height: 40px;\n    }\n  \n    .sidebar-page-container .news-block-one .inner-box .lower-content .inner{\n      margin-top: -30px;\n    }\n  \n    .pagination-wrapper{\n      text-align: center;\n    }\n  \n    .news-block-one .inner-box .lower-content .inner h2{\n      font-size: 24px;\n      line-height: 32px;\n    }\n  \n    .blog-details-content .inner-box .two-column .content-box{\n      margin-bottom: 30px;\n    }\n  \n    .blog-details-content .author-box .icon-layer{\n      display: none;\n    }\n  \n    .blog-details-content .nav-btn-box .left-btn{\n      margin-bottom: 30px;\n    }\n  \n    .blog-details-content .nav-btn-box{\n      margin-bottom: 40px;\n    }\n  \n    .protfolio-page{\n      padding: 70px 0px;\n    }\n  \n    .portfolio-wide-2 .masonry-item{\n      width: 100%;\n    }\n  \n    .locations-section{\n      padding: 70px 0px 40px 0px;\n    }\n  \n    #content_block_2 .content-box .inner-box{\n      padding: 50px 30px;\n    }\n  \n  }\n  \n  @media only screen and (max-width: 599px){\n   \n  \n    .main-header .logo-box{\n      text-align: center;\n    }\n  \n    .main-header .menu-right-content{\n      left: 0px;\n      bottom: 7px;\n      right: inherit;\n      top: auto;\n      padding-right: 0px;\n      padding-left: 15px;\n    }\n  \n    .main-header .menu-right-content .search-btn button{\n      color: #000;\n    }\n  \n    #content_block_1 .content-box .inner-box .list li{\n      width: 100%;\n      min-height: 65px;\n      margin-bottom: 15px;\n    }\n  \n    #content_block_1 .content-box .inner-box .list li:last-child{\n      margin-bottom: 0px;\n    }\n  \n    #content_block_3 .content-box .author-text h3{\n      font-size: 12px;\n      line-height: 1.5;\n    }\n  \n    .industries-section .tabs-content .inner-box .content-box .text{\n      margin-right: 0px;\n    }\n  \n    .industries-section .tabs-content .inner-box .content-box .text h2{\n      font-size: 30px;\n      line-height: 38px;\n    }\n  \n    .testimonial-style-two .testimonial-block-two{\n      margin: 0px;\n    }\n  \n    .main-header.style-three .logo-box{\n      width: 100%;\n    }\n  \n    .banner-section.style-three .slide-item{\n      padding-top: 260px;\n    }\n  \n    .hiring-section .inner-box .icon-box{\n      right: 30px;\n      bottom: 30px;\n    }\n  \n    .single-job-post .job-header .number{\n      float: none;display: block;\n      margin-top: 15px;\n    }\n  \n    .single-job-post .job-header .info{\n      float: none;\n      display: block;\n    }\n  \n    .job-details-content .upper-box .inner-box .company-logo{\n      position: relative;\n      margin-bottom: 15px;\n    }\n  \n    .job-details-content .upper-box .inner-box{\n      padding-left: 0px;\n    }\n  \n    .blog-details-content .comment-box .comment.reply-comment{\n      margin-left: 0px;\n    }\n  \n    .menu-area .mobile-nav-toggler{\n      margin-right: 15px;\n    }\n  \n    .rtl .main-header .menu-right-content{\n      padding: 0px;\n    }\n  \n    .rtl .industries-section .tabs-content .inner-box .content-box .text{\n      margin-left: 0px;\n    }\n  \n  }\n  \n  \n\n  @media (min-width: 600px) and (max-width: 991px)\n  {\n    .main-header .language .lang-btn\n{\n  background: #ffffff;\n}\n.main-header .menu-right-content .theme-btn-one {\n  background: #000000;\n}\n  }\n  @media  (min-width: 992px) and  (max-width: 1399px)\n{\n  #content_block_4 .content-box .inner-box .single-item .inner .icon-box {\n  display: none;\n}\n\n}\n\n@media  (min-width: 992px) and  (max-width: 1100px){\n\n#content_block_4 .content-box .inner-box .single-item\n{\n  padding: 15px 30px 5px 30px !important;\n  margin-bottom: 10px;\n}\n}\n.container, .container-fluid, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {\n  --bs-gutter-x: 0 !important;\n}\n  @media  (min-width: 992px) and  (max-width: 1600px){\n  \n.recruitment-technology .image-box img {\n  max-width: 161% !important;\n  float: right !important;\n  right: -22% !important;\n  position: relative !important;\n  opacity: 0.9;\n}\n \n}\n\n  @media only screen and (max-width: 499px){\n    .icon-box img {\n      width: 30px !important;\n  }\n    .industries-section .tab-btns li{\n    position: relative !important;\n    display: block !important;\n    padding: 0 0px 0 70px!important;\n    cursor: pointer!important;\n     min-height: 50px!important;\n    transition: all 500ms ease!important;\n    margin-bottom: 0 !important;\n   }\n    #content_block_1 .content-box .inner-box .list{\n      display: none;\n    }\n    .main-header .logo-box {\n       display: none;\n  }\n    .main-header .outer-box {\n      position: fixed !important;\n      width: 100% !important;\n      background: white !important;\n      top: 0;\n  }\n  \n    #login{\n      display: none;\n     }\n    figure {\n      margin:   0 !important;\n  }\n    .main-header .header-top{\n      padding: 0px 15px;\n      display: none;\n    }\n  \n    .industries-section .tabs-content .inner-box .content-box{\n      position: relative;\n      padding: 0px;\n    }\n  \n    .search-popup .search-form fieldset input[type=\"submit\"]{\n      position: relative;\n      border-radius: 7px;\n      display: block;\n      width: 100%;\n    }\n  \n    .search-popup .search-form fieldset input[type=\"search\"]{\n      padding-right: 30px;\n      margin-bottom: 15px;\n    }\n  \n    .banner-carousel .btn-box a{\n      margin: 5px 5px;\n    }\n  \n    .feature-section{\n      padding: 0px 15px;\n    }\n  \n    #image_block_1 .image-box .video-inner{\n      position: relative;\n      max-width: 100%;\n      margin-bottom: 30px;\n    }\n  \n    .about-style-two #image_block_1 .image-box{\n      padding: 0px;\n    }\n  \n    #image_block_1 .image-box .image-2{\n      position: relative;\n      text-align: center;\n      margin-top: 30px;\n    }\n  \n    .industries-style-two .tabs-content-2 .inner-box .content-box{\n      padding: 0px 15px;\n    }\n  \n    .industries-style-two .tabs-content-2 .inner-box .content-box .link{\n      right: 15px;\n      margin-left: 15px;\n    }\n  \n    .industries-style-two .tabs-content-2 .inner-box .content-box .text h2{\n      font-size: 24px;\n      line-height: 30px;\n    }\n  \n    .clients-style-two .title-inner .btn-box a{\n      margin: 5px 5px;\n    }\n  \n    .main-footer.style-two .footer-bottom .copyright .footer-logo{\n      position: relative;\n      margin-bottom: 15px;\n    }\n  \n    .main-footer.style-two .footer-bottom .copyright{\n      padding-left: 0px;\n    }\n  \n    .banner-carousel .content-box h2{\n      font-size: 30px;\n      line-height: 36px;\n    }\n  \n    .video-section #image_block_1 .image-box .video-inner{\n      padding: 150px 0px 140px 0px;\n    }\n  \n    .solutions-problems .carousel-box .single-item .inner-box .lower-content h3{\n      font-size: 20px;\n      line-height: 28px;\n    }\n  \n    .contact-section .form-inner{\n      padding: 50px 30px;\n    }\n  \n    .job-details-content .social-box .social-links li{\n      width: 50%;\n    }\n  \n    .job-details-content .social-box .social-links{\n      text-align: center;\n    }\n  \n    .job-details-content .social-box .social-links li{\n      float: none;\n    }\n  \n    .sidebar-page-container .news-block-one .inner-box .lower-content .inner .share-box{\n      position: relative;\n      right: 0px;\n      bottom: 0px;\n      margin-left: 0px;\n    }\n  \n    .blog-details-content .post-share-option .social-box .social-links{\n      text-align: center;\n    }\n  \n    .blog-details-content .post-share-option .social-box .social-links li{\n      width: 100%;\n      float: none;\n    }\n  \n    .blog-details-content .author-box .signature{\n      position: relative;\n      top: 0px;\n    }\n  \n    .blog-details-content .author-box{\n      padding: 40px 30px 50px 30px;\n    }\n  \n    .blog-details-content .comment-box .comment .comment-inner .comment-info .comment-time{\n      position: relative;\n      top: 0px;\n    }\n  \n    .blog-details-content .comments-form-area{\n      padding: 50px 30px;\n    }\n  \n    .contact-page-section .form-inner{\n      padding: 50px 30px;\n    }\n  \n    .locations-section .single-item .inner-box{\n      padding-left: 30px;\n      padding-right: 30px;\n    }\n  \n  \n  \n  }\n  \n  \n  @media only screen and (max-width: 399px){\n    .service-block-one .inner-box .lower-content .content-box .link a,.service-block-one .inner-box .lower-content .overlay-content a,.process-block-one .inner-box .lower-content a {\n   \n      font-size: 11px !important;\n    }\n    #content_block_1 .content-box .inner-box .link a i {\n      top: 0;\n      font-size: 16px;\n    }\n    a.theme-btn-two{\n      font-size: 12px !important;\n\n    }\n    p,.industries-section .tabs-content .inner-box .content-box .text span{\n       font-size: 13px !important;\n    }\n    h5 {\n      font-size: 16px !important;\n   }\n   h3,h2, h4,a{\n       font-size: 15px !important;\n    }\n    #content_block_1 .content-box .tab-btns li {\n      padding: 10px 40px 10px 40px;\n    }\n    #content_block_1 .content-box .inner-box p {\n      font-size: 12px;\n      text-align: justify;\n    }\n    #content_block_1 .content-box .tab-btns li h5 {\n      font-size: 15px;\n    }\n    .banner-carousel .content-box h1 br{\n      display: none;\n    }\n    .sec-title p {\n      font-size: 12px;\n      text-align: justify;\n    }\n   \n    .sec-title h2,\n    #content_block_1 .content-box .inner-box h2,\n    .clients-style-two .title-inner h2,\n    .hiring-strategies .inner-box .title-inner h2,\n    .hiring-section .inner-box h2,\n    .growth-style-two .inner-column .text h2{\n      font-size: 14px;\n      line-height: 36px;\n    }\n  \n    .banner-carousel .content-box h1,\n    .banner-section.style-three .banner-carousel .content-box h1{\n      font-size: 25px;\n      line-height: 40px;\n    }\n  \n    .testimonial-block-one .inner-box{\n      padding-left: 30px;\n    }\n  \n    .testimonial-block-one .inner-box .author-box{\n      padding-left: 0px;\n    }\n  \n    .testimonial-block-one .inner-box .author-box .author-thumb{\n      position: relative;\n      display: inline-block;\n      top: 0px;\n      margin-bottom: 15px;\n    }\n  \n    .industries-style-two .tab-btn-two li h3{\n      font-size: 15px;\n      line-height: 26px;\n    }\n  \n    .rtl .testimonial-block-one .inner-box .author-box{\n      padding-right: 0px;\n    }\n  \n    .hiring-strategies .inner-box .funfact-inner .counter-block{\n      padding-left: 160px;\n    }\n  \n    .hiring-strategies .inner-box .funfact-inner .counter-block .count-outer{\n      left: 30px;\n    }\n  \n    .solutions-problems .carousel-box .single-item .inner-box .lower-content h3{\n      position: relative;\n      border-radius: 0px;\n      border-bottom-left-radius: 10px;\n    }\n  \n    .solutions-problems .carousel-box .single-item .inner-box .lower-content{\n      margin-left: 0px;\n    }\n  \n    .solutions-problems .carousel-box .single-item .inner-box .image-box,\n    .solutions-problems .carousel-box .single-item .inner-box .image-box img{\n      border-bottom-left-radius: 0px;\n    }\n  \n    .placejob-section .form-inner .title-inner{\n      padding-left: 0px;\n    }\n  \n    .placejob-section .form-inner .title-inner .icon-box{\n      position: relative;\n      top: 0px;\n      margin-bottom: 15px;\n    }\n  \n    .clients-style-three #image_block_1 .image-box .video-inner{\n      padding: 150px 0px 130px 0px;\n    }\n  \n    .service-details-content .content-three .tabs-content .inner-box .text{\n      position: relative;\n      width: 100%;\n      border-radius: 10px;\n      margin: 0px;\n    }\n  \n    .service-details-content .content-three .tabs-content .inner-box .image-box{\n      margin-bottom: 30px;\n    }\n  \n    .single-job-post .job-header .info li a{\n      margin-bottom: 10px;\n    }\n  \n    .single-job-post .job-title{\n      padding-left: 0px;\n    }\n  \n    .single-job-post .job-title .company-logo{\n      position: relative;\n      margin-bottom: 10px;\n    }\n  \n    .single-job-post .job-header .number{\n      margin-top: 5px;\n    }\n  \n    .job-details-content .upper-box .inner-box{\n      padding-right: 0px;\n    }\n  \n    .sidebar-page-container .news-block-one .inner-box .lower-content .inner{\n      padding-left: 30px;\n    }\n  \n    .blog-details-content .post-share-option .tag-list li{\n      margin: 3px 2px;\n    }\n  \n    .main-footer .footer-subscribe h3{\n      font-size: 18px;\n      line-height: 26px;\n    }\n  \n    .error-section .error-content h2{\n      font-size: 32px;\n      line-height: 40px;\n    }\n  \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
